const header = document.querySelector(".header");

if (header) {
  const updateHeader = () => {
    header.classList.toggle("header--scrolled", window.scrollY > 0);
  };

  window.addEventListener("scroll", updateHeader, { passive: true });

  // Set the initial state, too.
  updateHeader();
}
